import { buildScopedI18n } from '../../utils/buildScopedI18n';
import homeEsCL from './locales/es-CL.json';
import homeEnUS from './locales/en-US.json';
import homePtBR from './locales/pt-BR.json';

export const homeI18n = buildScopedI18n({
  esCL: homeEsCL,
  enUS: homeEnUS,
  ptBR: homePtBR,
});
